import axios from 'axios'

import { checkKeycloakToken } from './auth/hooks/useKeycloakToken'

export const RestApiPoaService = axios.create({
  baseURL: '/poa-service/api/v1',
})

RestApiPoaService.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
  'Content-Type': 'application/json',
}

RestApiPoaService.interceptors.request.use(checkKeycloakToken)
